import { render, staticRenderFns } from "./LobbyFormDialog.vue?vue&type=template&id=0af38608&scoped=true"
import script from "./LobbyFormDialog.vue?vue&type=script&lang=js"
export * from "./LobbyFormDialog.vue?vue&type=script&lang=js"
import style0 from "./LobbyFormDialog.vue?vue&type=style&index=0&id=0af38608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af38608",
  null
  
)

export default component.exports